export function customSelectLanguage({ options, placeholder, value = null, name, form, getErrors }) {
  return {
    options,
    placeholder,
    name,
    form,
    get errors() {
      return getErrors()[this.name];
    },
    open: false,
    value: value,
    init() {
      if (typeof form !== 'undefined' && form[this.name]) {
        const currentCode = form[this.name];
        this.value = this.options.find(o => o.image_code === currentCode) ?? null;
      }

      this.$watch(() => form[this.name], (newCode) => {
        this.value = this.options.find(o => o.image_code === newCode) ?? null;
      });
    },
    select(option) {
      this.value = option;
      this.open = false;
      if (typeof form !== 'undefined') {
        form[this.name] = option ? option.image_code : '';
      }
      this.$nextTick(() => {
        this.value = option;
      });
    },
    isSelected(option) {
      return this.value && this.value.image_code === option.image_code;
    },
    get displayTitle() {
      return this.value?.localization?.title || this.placeholder;
    }
  };
}
